import { useCallback, useEffect, useMemo, useState } from "react";

import {
	ReservationDetailChargeCancelFeeInputZodSchema,
	type ReservationDetailChargeCancelFeeInputType,
} from "./validation-schema";

import type { SafeParseError } from "zod";

export const useHandleFormState = (willCancelFeeChargePrice: number) => {
	// 初期値は請求可能額（上限）。施設が必要に応じて減額できる。
	const [chargePrice, setChargePrice] = useState<number | undefined>(willCancelFeeChargePrice);
	/**
	 * 請求するキャンセル料金を更新
	 */
	const handleChangeChargePrice = useCallback((value: number | undefined) => {
		setChargePrice(value);
	}, []);

	const [validationErrors, setValidationErrors] = useState<
		SafeParseError<ReservationDetailChargeCancelFeeInputType> | undefined
	>(undefined);
	/**
	 * state の変更を監視し、バリデーションを実行
	 */
	useEffect(() => {
		const zodErrors = ReservationDetailChargeCancelFeeInputZodSchema.safeParse({ chargePrice });

		zodErrors.success ? setValidationErrors(undefined) : setValidationErrors(zodErrors);
	}, [chargePrice]);

	const chargePriceErrorMessage = useMemo(
		() => validationErrors?.error.formErrors.fieldErrors.chargePrice?.at(0),
		[validationErrors?.error.formErrors.fieldErrors.chargePrice],
	);
	const hasError = useMemo(() => validationErrors !== undefined, [validationErrors]);

	return {
		chargePrice,
		chargePriceErrorMessage,
		hasError,
		//
		handleChangeChargePrice,
	};
};
